import { atom } from "recoil"


export const ContextTypesState = atom({
    key: "contextTypes",
    default: {}
})